import actions from './actions';
import mutations from './mutations';

function state() {
	return {
        markupDialogOpen: false,
        has_active_cost_split: false,
        cellSize: 10,

        markupForm: {
            id: '',
            media_id: '',
            name: '',
            member_share: '',
            comarketer_share: '',
            markup_image: '',
            is_active: true,
            hideEdit: true,
            current_image: true,
            keep_image: '0',
            currently_drawing_role: 'Loan Officer',
            currently_drawing_color: 'text-danger',
            share_reset: {
                member_share_reset: '',
                comarketer_share_reset: ''
            }
        },

        selection: {
        	is_made: false,
        	is_visible: false,
        	left: 0,
        	top: 0,
        	width: 0,
        	height: 0
        },

        mouse: {
        	is_down_in_template: false,
        	x1: 0,
        	x2: 0,
        	y1: 0,
        	y2: 0
        }
	};
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
};